import api from '../apis/ufrnApi'

const searchService = ({title, author, subject, limit, offset, isRepository, library = 0, materialType = 0}) => {
    let params = {
        titulo: title,
        autor: author,
        assunto: subject,
    }

    //Removing empty entries
    params = Object.entries(params).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
    const urlParams = new URLSearchParams(params).toString()

    let url;
    if (isRepository) {
        url = `/repositorios/?${urlParams}&limit=${limit}&offset=${offset}`
        url = materialType != 'all' ? `${url}&item_type=${materialType}` : url
    } else {
        url = `/acervos/?${urlParams}&limit=${limit}&offset=${offset}`
        url = !!library ? `${url}&id-biblioteca=${library}` : url
        url = !!materialType ? `${url}&id-tipo-material=${materialType}` : url
    }
    
    return api.get(url)
}

export default searchService